<template>
  <router-link
    v-if="visible"
    :to="campaignPath"
    class="campaign-top-banner"
    aria-label="双十一充值钜惠，查看活动"
  >
    <img src="@/assets/images/header/banner.gif" alt="双十一充值钜惠" />
  </router-link>
</template>

<script>
import { DOUBLE_ELEVEN } from "@/utils/doubleEleven";

export default {
  props: {
    visible: { type: Boolean, default: true },
  },
  data() {
    return { campaignPath: DOUBLE_ELEVEN.path };
  },
};
</script>

<style lang="scss" scoped>
.campaign-top-banner {
  position: relative;
  display: block;
  width: 100%;
  height: 44px;
  overflow: hidden;
  background: #ea2d3e;
  cursor: pointer;

  img {
    position: absolute;
    top: 0;
    left: 50%;
    width: 1920px;
    max-width: none;
    height: 44px;
    transform: translateX(-50%);
  }

  &:focus-visible {
    outline: 2px solid #ffdc87;
    outline-offset: -3px;
  }
}

@media (max-width: 760px) {
  .campaign-top-banner {
    height: 36px;

    img {
      width: auto;
      height: 36px;
    }
  }
}
</style>
